
import './App.css';
import Navbar from './Components/Basics/Navbar';
import Footer from './Components/Basics/Footer';
import Card from './Components/Basics/Card';
import Navtop from './Components/Basics/Navtop';
import ScrollButton from './Components/Basics/ScrollButton';




function App() {
  return (
    <div>
       <Navtop/>
      <Navbar/>
      <Card/>
      <Footer/>
      <ScrollButton />
    </div>
  );
}

export default App;
